export const PACKAGE_VERSION = '0.24.0';
//# sourceMappingURL=package-version.js.map